module.exports = __webpack_public_path__ + "static/media/debbie_chang.47437151.jpg";